<template>
  <div style="width:100%; height:96%">
<!--    <iframe width="100%" height="500px" id="template-iframe" ref="iframe" :src="src" frameborder="0" scrolling="no"></iframe>-->
  </div>
</template>

<script>

export default {
  name: 'Map',
  data () {
    return {
      msg: 'Welcome to Dns'
    }
  },
  created () {
    window.location = 'http://fujzz.bj01.bdysite.com/map/'
    // this.list()
  },
  mounted () {
    // setInterval(this.getHeight, 100)
  },
  computed: {
    // src () {
    //   return 'http://fujzz.bj01.bdysite.com/map/gps.html'
    // }
  },
  methods: {
    // getHeight () {
    //   console.log(document.body.clientHeight)
    //   document.getElementById('iframe').height = document.body.clientHeight
    // }
    //
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/Map.vue